import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { CSSTransition } from 'react-transition-group'
import { createDivAtom } from 'shared/atoms/factory'
import InlineSVG from 'svg-inline-react'

import styles from './Popover.module.scss'

import iconDropDown from '!raw-loader!shared/assets/icons/dropdown.svg'

const TriggerWrapper = createDivAtom(),
      PopoverWrapper = createDivAtom()

class Popover extends Component {

  state = {
    showPopover: false
  }

  hide = () => {
    document.removeEventListener('click', this.handleOutsideClick, false)

    this.setState({
      ...this.state,
      showPopover: false
    })
  }

  handleOutsideClick = e => {
    if (this.node?.contains(e.target)) return

    this.handleClick()
  }
  
  handleClick = () => {
    const { showPopover } = this.state

    if (!showPopover) {
      document.addEventListener('click', this.handleOutsideClick, false)
    } else {
      document.removeEventListener('click', this.handleOutsideClick, false)
    }

    this.setState({
      ...this.state,
      showPopover: !showPopover
    })
  }

  render = () => (
    <main
      ref={ref => this.node = ref}
      className={styles.wrapper}
    >
      <TriggerWrapper
        className={styles.triggerWrapper}
        onClick={this.handleClick}
      >
        {this.props.trigger}

        {this.props.showChevron && (
          <InlineSVG
            className={styles.icon}
            src={iconDropDown}
          />
        )}
      </TriggerWrapper>

      <CSSTransition
        in={this.state.showPopover}
        timeout={300}
        classNames='item-fade'
        unmountOnExit
      >
        <PopoverWrapper
          className={classNames(
            styles.popoverWrapper,
            styles.bottom,
            this.props.position === 'bottom-right' && styles.bottomRight
          )}
        >
          {this.props.children}
        </PopoverWrapper>
      </CSSTransition>
    </main>
  )
}

Popover.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.array
  ]).isRequired,
  trigger: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.array
  ]).isRequired,
  showChevron: PropTypes.bool,
  position: PropTypes.string
}

export default Popover
